import { render, staticRenderFns } from "./reporte-general-jugador.vue?vue&type=template&id=6e994519&scoped=true"
import script from "./reporte-general-jugador.vue?vue&type=script&lang=js"
export * from "./reporte-general-jugador.vue?vue&type=script&lang=js"
import style0 from "./reporte-general-jugador.vue?vue&type=style&index=0&id=6e994519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e994519",
  null
  
)

export default component.exports